<template>
  <IndexPageSection
    v-if="displayableNewArrival"
    :link-string="'一覧へ'"
    :link-url="'/items?sort_key=new_arrival'"
    :need-to-move-link-to-bottom="false"
    :section-name="'new-arrival'"
    :title="'新着のギフトから探す'"
  >
    <div class="special-feature__lead">
      <div v-if="isLoading" class="new-arrival__loading">
        <Loading />
      </div>
      <div v-else class="new-arrival__items">
        <div class="new-arrival__horizontal-scroll">
          <HorizontalScroll ref="new-arrival-horizontal" ref-name="new-arrival">
            <ItemBoxes
              :items="newArrivalItems"
              :scrollable="false"
              @mount="onMountItemBoxes"
              @click-item-box="onClickItemBox"
            />
          </HorizontalScroll>
        </div>
      </div>
    </div>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection.vue'
import ItemBoxes from '../../../molecules/item_boxes/ItemBoxes.vue'
import Loading from '../../../atoms/loadings/Loading.vue'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'
import SearchItemsQuery from '../../../../../../graphqls/public/queries/search_items'
import SearchedItem from '../../../../utils/searched-item.js'
export default {
  components: { IndexPageSection, ItemBoxes, Loading, HorizontalScroll },
  data() {
    return {
      newArrivalItems: [],
      isLoading: false
    }
  },
  computed: {
    displayableNewArrival() {
      return !this.isLoading && this.newArrivalItems.length !== 0
    }
  },
  mounted() {
    this.getNewArrivalItems()
  },
  methods: {
    onClickItemBox(itemId) {
      dataLayer.push({
        event: 'click_top__latest_item_detail',
        item_id: itemId
      })
    },
    async getNewArrivalItems() {
      this.isLoading = true
      try {
        const response = await this.$apollo.provider.clients.publicClient.query(
          {
            query: SearchItemsQuery,
            variables: {
              keyword: '',
              pageNumber: 1,
              itemPerPage: 30,
              sortKey: 'new_arrival'
            }
          }
        )
        this.newArrivalItems = response.data.searchItems.items.map(item =>
          SearchedItem.createSearchedItemObject(item)
        )
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
      this.isLoading = false
    },
    onMountItemBoxes() {
      this.$refs['new-arrival-horizontal'].initializeValues()
    }
  }
}
</script>
